<app-header></app-header>
<div class="body-container" [ngClass]="{'closed': !options.open}">
    <a class="live-chat hide-mobile" target="_blank"
        href="https://home-c35.nice-incontact.com/incontact/chatclient/chatclient.aspx?poc=97e77c7f-d8a6-4af0-95eb-f8975110c562&bu=4599274">
        <img src="/assets/images/icons/live_chat.svg" />
    </a>
    <div>
        <div id="application" aria-labelledby="application-tab">
            <app-application-list-application-tab></app-application-list-application-tab>
        </div>
    </div>
</div>
<ngx-guided-tour></ngx-guided-tour>